"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigMapSchema = exports.AnyConfigSchema = exports.MinimalConfigSchema = exports.StandardConfigSchema = exports.ConfigError = void 0;
exports.minimalToMap = minimalToMap;
exports.standardToMap = standardToMap;
exports.mapToMinimal = mapToMinimal;
exports.mapToStandard = mapToStandard;
const zod_1 = require("zod");
var ConfigError;
(function (ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
})(ConfigError || (exports.ConfigError = ConfigError = {}));
exports.StandardConfigSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    value: zod_1.z.union([
        zod_1.z.boolean(),
        zod_1.z.string(),
        zod_1.z.number(),
        zod_1.z.string().array(),
        zod_1.z.number().array(),
    ]),
}));
exports.MinimalConfigSchema = zod_1.z.tuple([
    // list of boolean configs which are on
    zod_1.z.string().array(),
    // list of string config tuples
    zod_1.z.array(zod_1.z.string()).refine((arr) => arr.length % 2 === 0),
    // list of number config tuples
    zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])).refine((arr) => {
        if (arr.length % 2 !== 0)
            return false;
        for (let i = 0; i < arr.length; i += 2) {
            if (typeof arr[i] !== "string")
                return false;
            if (typeof arr[i + 1] !== "number")
                return false;
        }
        return true;
    }),
    // list of string list config tuples
    zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.string().array()])).refine((arr) => {
        if (arr.length % 2 !== 0)
            return false;
        for (let i = 0; i < arr.length; i += 2) {
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== "string")
                return false;
            if (!Array.isArray(val) || !val.every((x) => typeof x === "string"))
                return false;
        }
        return true;
    }),
    // list of number list config tuples
    zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number().array()])).refine((arr) => {
        if (arr.length % 2 !== 0)
            return false;
        for (let i = 0; i < arr.length; i += 2) {
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== "string")
                return false;
            if (!Array.isArray(val) || !val.every((x) => typeof x === "number"))
                return false;
        }
        return true;
    }),
]);
exports.AnyConfigSchema = zod_1.z.union([
    exports.StandardConfigSchema,
    exports.MinimalConfigSchema,
]);
exports.ConfigMapSchema = zod_1.z.map(zod_1.z.string(), zod_1.z.object({
    value: zod_1.z.union([
        zod_1.z.boolean(),
        zod_1.z.string(),
        zod_1.z.number(),
        zod_1.z.string().array(),
        zod_1.z.number().array(),
    ]),
}));
function pairs(arr, fn) {
    for (let i = 0; i < arr.length; i += 2) {
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== "string") {
            throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        }
        fn(key, val);
    }
}
function minimalToMap(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean) => map.set(boolean, { value: true }));
    pairs(minimal[1], (a, b) => map.set(a, { value: b }));
    pairs(minimal[2], (a, b) => map.set(a, { value: b }));
    pairs(minimal[3], (a, b) => map.set(a, { value: b }));
    pairs(minimal[4], (a, b) => map.set(a, { value: b }));
    return map;
}
function standardToMap(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value]) => map.set(key, value));
    return map;
}
function mapToMinimal(map) {
    const minimal = [[], [], [], [], []];
    for (const [key, { value }] of map.entries()) {
        switch (typeof value) {
            case "boolean":
                if (value) {
                    minimal[0].push(key);
                }
                break;
            case "string":
                minimal[1].push(key, value);
                break;
            case "number":
                minimal[2].push(key, value);
                break;
            default:
                if (!Array.isArray(value)) {
                    throw new Error(`Unexpected configuration value: ${value}`);
                }
                const allStrings = value.every((x) => typeof x === "string");
                if (allStrings) {
                    minimal[3].push(key, value);
                    break;
                }
                const allNumbers = value.every((x) => typeof x === "number");
                if (allNumbers) {
                    minimal[4].push(key, value);
                    break;
                }
                throw new Error(`Unexpected configuration value: ${value}`);
        }
    }
    return minimal;
}
function mapToStandard(map) {
    return Object.fromEntries(map.entries());
}
